import { VEHICLE_TYPE } from '@/entities/car/lib'
import { clientHttp } from '@/shared/api/client'
import { CLIENT_API_ENDPOINTS } from '@/shared/lib'

import '../../model/handledErrors'

import type {
  IMacar,
  ICarModel,
  ICarBrand,
  ICarDetailModel,
  IVehicleOptions,
  ICreateMyCarByModelRequest,
  ICreateMyCarByModelSuccessResponse,
} from '@/entities/car/model'

export const getCarBrandList = async ({
  params,
}: {
  params: {
    vehicleType: (typeof VEHICLE_TYPE)[keyof typeof VEHICLE_TYPE]
  }
}): Promise<ICarBrand[]> => {
  return await clientHttp.get(CLIENT_API_ENDPOINTS.CAR.BRAND, {
    params,
  })
}

export const getCarModelList = async (
  brandId: number
): Promise<ICarModel[]> => {
  return await clientHttp.get(CLIENT_API_ENDPOINTS.CAR.MODEL(brandId))
}

export const getCarDetailModelList = async (
  brandId: number,
  carId: number
): Promise<ICarDetailModel[]> => {
  return await clientHttp.get(
    CLIENT_API_ENDPOINTS.CAR.DETAIL_MODEL({ brandId, carId })
  )
}

export const createMyCarByModel = (
  carInfo: ICreateMyCarByModelRequest
): Promise<ICreateMyCarByModelSuccessResponse> => {
  return clientHttp.post(CLIENT_API_ENDPOINTS.CAR.CREATE_MY_CAR_BY_MODEL, {
    body: carInfo,
  })
}

/**
 * 고를 트림이 없으면 trims 가 빈 배열로, 세부모델 자체가 없으면 204(본문 없음)로 온다.
 */
export const getVehicleOptions = async ({
  standardId,
  fuelType,
}: {
  standardId: number
  fuelType?: string
}): Promise<IVehicleOptions | null> => {
  return await clientHttp.get(
    CLIENT_API_ENDPOINTS.CAR.VEHICLE_OPTIONS({ standardId, fuelType })
  )
}

export const getAllMacar = async (): Promise<IMacar[]> => {
  return clientHttp.get(CLIENT_API_ENDPOINTS.CAR.MACAR)
}

/** 로그인한 사용자의 차량만 조회된다. */
export const getMacarDetail = async (macarId: number): Promise<IMacar> => {
  return await clientHttp.get(CLIENT_API_ENDPOINTS.CAR.MACAR_DETAIL(macarId))
}
